import { Address } from 'viem';

export const FUSION_NFT: Address = '0x68f3705655bBB044178234ccBfa51748a7A095F2';
export const REWARD_POOL: Address =
  '0x7e8cab16203fc04694bac2f07a4bd83e437df775';

export const MARKETPLACE: Address =
  '0x3ec1aDacc2aa438F843098e9cCe3643AdeD61ed3';

export const HYPERDRIVER_VAULT: Address =
  '0x1BA829efa176e5f95b09e79669aB3d4588E3b015';
